import { createTheme } from '@material-ui/core';

const styles = theme => {
  return {
    root: {
      paddingTop: '20px',
      fontSize: '12px',
      width: '100%'
    },
    label: {
      fontSize: '14px',
      fontWeight: 500,
      marginBottom: '20px'
    },
    container: {
      display: 'flex',
      marginTop: '20px',
      width: '100%',
      flexDirection: 'column',
      borderBottom: '1px solid #EBEDF2'
    },
    dirFieldsContainer: {
      flexDirection: 'row',
      display: 'grid',
      gridTemplateColumns: 'auto auto',
      [theme.breakpoints.down(theme.breakpoints.values.md - 100)]: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    smallLabel: {
      fontWeight: 700,
      marginLeft: '20px'
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      [theme.breakpoints.down(theme.breakpoints.values.md - 100)]: {
        flexDirection: 'column'
      }
    },
    numberContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '10px'
    },
    numberRow: {
      display: 'flex'
    },
    box: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: '10px'
    },
    labelBox: {
      marginRight: '10px'
    },
    boxRow: { display: 'flex', alignItems: 'center', paddingTop: '15px' },
    aliasBoxRow: { display: 'flex', alignItems: 'center' },
    mobilePhonesContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    addIcon: {
      fontSize: '14px',
      cursor: 'pointer',
      marginLeft: '10px'
    },
    deleteIcon: {
      fontSize: '14px',
      cursor: 'pointer',
      marginLeft: '10px'
    },
    addPhoneBox: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '10px'
    },
    textField: {
      marginRight: '20px'
    },
    clearableInput: {
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
      '& > button, & > span': {
        marginTop: '23px'
      }
    },
    addNumberBox: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '10px',
      marginBottom: '10px',
      border: '1px solid #EBEDF2',
      padding: '10px',
      borderRadius: '5px',
      backgroundColor: '#F9FAFB'
    }
  };
};

export default styles;

export const checkboxCustomStyles = {
  root: { width: '182px' }
};

export const selectCustomStyles = {
  root: { width: '420px' },
  control: {
    borderRadius: '5px'
  },
  value: { width: '275px' }
};

export const textfieldsStyles = {
  root: { width: '420px' },
  textfield: { backgroundColor: '#FFF', width: '275px' }
};
